import { cva } from "class-variance-authority";

/**
 * Duration for standard sidebar animations in milliseconds
 */
export const TRANSITION_DURATION = 200; // Must match the Tailwind duration-200 class

/**
 * Duration for fast text fade animations in milliseconds
 */
export const TEXT_FADE_DURATION = 100; // Half the sidebar transition for quick fade

/**
 * Standard transition classes for sidebar animations
 */
const transitionClasses = {
    all: "transform-gpu transition-all duration-200 ease-out",
    transform: "transform-gpu transition-transform duration-200 ease-out",
    opacity: "transform-gpu transition-opacity duration-200 ease-out",
    fastOpacity: "transform-gpu transition-opacity duration-100 ease-out",
    list: "transform-gpu transition-[height,opacity] duration-200 ease-out",
} as const;

export const TRANSITION_CLASSES = transitionClasses.all;
export const LIST_TRANSITION_CLASSES = transitionClasses.list;
export const FAST_FADE_CLASSES = transitionClasses.fastOpacity;

export const sidebarButtonVariants = cva(
    // Base styles that are always applied
    "flex flex-row items-center rounded-lg",
    {
        variants: {
            design: {
                new: "h-8 min-w-0",
            },
            state: {
                active: "bg-surface-hover",
                default: "hover:bg-surface-hover",
            },
        },
        defaultVariants: {
            design: "new",
            state: "default",
        },
    },
);

export const iconContainerVariants = cva(
    // Base styles
    "relative",
    {
        variants: {
            design: {
                new: "w-8 shrink-0",
            },
        },
        defaultVariants: {
            design: "new",
        },
    },
);

export const iconVariants = cva(
    // Base styles
    transitionClasses.transform,
    {
        variants: {
            design: {
                new: "flex items-center justify-center",
            },
        },
        defaultVariants: {
            design: "new",
        },
    },
);

export const labelVariants = cva(
    // Base styles
    "flex-grow text-start text-base",
    {
        variants: {
            design: {
                new: ["min-w-0 overflow-hidden whitespace-nowrap", transitionClasses.opacity],
            },
            visibility: {
                hidden: "w-0 opacity-0",
                visible: "opacity-100",
            },
        },
        defaultVariants: {
            design: "new",
            visibility: "visible",
        },
    },
);

export const badgeVariants = cva(
    // Base styles that are always applied
    "flex size-2 items-center justify-center",
    {
        variants: {
            design: {
                new: "absolute right-1 mt-1 -top-1",
            },
            status: {
                notification: "rounded-full bg-content-negative",
            },
        },
        defaultVariants: {
            design: "new",
            status: "notification",
        },
    },
);
